import { useEffect, useState } from "react";
import { api } from "../../App";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ChevronsUpDown } from "lucide-react";

export const TargetPicker = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => {
      api.get(`/call-logs/targets?q=${encodeURIComponent(q)}`).then((r) => setItems(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [q, open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className="w-full justify-between font-normal" data-testid="log-call-target-trigger">
          {value ? value.name : "Select client or lead..."}
          <ChevronsUpDown className="h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width] bg-white" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder="Search name or number..." value={q} onValueChange={setQ} data-testid="log-call-target-search" />
          <CommandList>
            <CommandEmpty>No match</CommandEmpty>
            <CommandGroup>
              {items.map((it) => (
                <CommandItem key={`${it.entity_type}-${it.entity_id}`} value={`${it.entity_type}-${it.entity_id}`} onSelect={() => { onChange(it); setOpen(false); }} data-testid={`log-call-target-${it.entity_id}`}>
                  <Badge variant="outline" className={`mr-2 text-[10px] ${it.entity_type === "lead" ? "border-amber-400 text-amber-700" : "border-blue-400 text-blue-700"}`}>{it.entity_type === "lead" ? "Lead" : "Client"}</Badge>
                  {it.name}{it.number ? <span className="ml-1 text-xs text-gray-500">({it.number})</span> : null}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
